import styled from 'styled-components/macro'
import { FaAngleRight } from 'react-icons/fa'
import { Button } from 'reactstrap'

const UrlField = styled.div`
  width: 80%;
  text-align: left;
  padding: 3px;
  border-radius: 2px;
  border: 2px solid #bebebe;
  padding-left: 5px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const ShareViaText = styled.span`
  margin-left: 20px;
  align-self: center;
`

const RightArrow = styled(FaAngleRight)`
  margin-left: auto;
  align-self: center;
`

const ButtonSelectAnother = styled(Button)`
  margin-left: auto;
`

export { UrlField, ShareViaText, RightArrow, ButtonSelectAnother }
